import styles from "./radio.module.css";

const CustomRadio = ({ label, name, value, checked, onChange, subText, disabled, title, customClass, tag }) => {
	const handleClick = (e) => {
		if (disabled) return;
		// Prevent default radio behavior
		e.preventDefault();
		// Create a synthetic event with target value
		const syntheticEvent = {
			target: { value }
		};
		// Call onChange which will handle the toggle logic
		onChange(syntheticEvent);
	};

	return (
		<label
			className={`${styles.radioWrapper} ${disabled ? styles.disabled : ""} ${customClass || ""}`}
			onClick={handleClick}
			title={title}
			aria-disabled={disabled}
		>
			<input
				type="radio"
				name={name}
				value={value}
				checked={checked}
				onChange={(e) => e.preventDefault()} // Prevent default change behavior
				disabled={disabled}
				readOnly
			/>
			<span className={styles.customRadio}></span>
			<div className={styles.content}>
				{label && <h6 className={styles.labelText}>{label}</h6>}
				{subText && <p>{subText}</p>}
			</div>
			{tag && <div className={styles.tag}>{tag}</div>}
		</label>
	);
};

export default CustomRadio;
